import authService from './authService';
import { buildHeaders, buildHeadersForUpload } from "src/utils/apiUtils";

let BASE_URL = process.env.REACT_APP_API_URL

export async function loadConfig() {
  // .env is used directly; no encrypted config to load.
}

loadConfig().then(() => {
});

export async function createQuestion(body:any) {
    try{
     const headers = await buildHeaders(BASE_URL);
     const response = await fetch(`${BASE_URL}/bank-questions`, {
         method: "POST",
         headers,
         body: JSON.stringify(body),
         credentials: "include",
     });


     const data = await response.json();
     if (!response.ok || !data.success) {
         if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
             throw new Error("Forbidden: You do not have permission to access this resource.");
         }
         //console.log("Failed to fetch");
     }
     return data;
 } catch (error: any) {
     //console.log(error);
 }
}

export async function fetchAllDataApi( options: RequestInit = {}): Promise<any> {
    const headers = await buildHeaders(BASE_URL);
    try {
      const response = await fetch(`${BASE_URL}/bank-questions?perPage=500&pageNo=1&query=`, {
        ...options,
        headers,
        credentials: "include"
      });
  
      const data = await response.json();
  
      if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        //console.log("Failed to fetch");
      }
      return data;
    } catch (error: any) {
    
    }
  }

export async function fetchDataApi(url: string, options: RequestInit = {}): Promise<any> {
    const headers = await buildHeaders(BASE_URL);
    try {
      const response = await fetch(`${BASE_URL}/${url}`, {
        ...options,
        headers,
        credentials: "include"
      });
  
      const data = await response.json();
  
      if (!response.ok || !data.success) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        //console.log("Failed to fetch");
      }
      return data;
    } catch (error: any) {
     
    }
  }


  export async function createSurvey(body:any) {
    try{
     const headers = await buildHeaders(BASE_URL);
     const response = await fetch(`${BASE_URL}/publicSurvey`, {
         method: "POST",
         headers,
         body: JSON.stringify(body),
         credentials: "include",
     });

     


     const data = await response.json();
     if (!response.ok || !data.success) {
         if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
             throw new Error("Forbidden: You do not have permission to access this resource.");
         }
         //console.log("Failed to fetch");
     }
     return data;
 } catch (error: any) {
     //console.log(error);
 }
}



export async function deleteSurveyApi(id: string): Promise<void> {
  try {
    const headers = await buildHeaders(BASE_URL);
    const response = await fetch(`${BASE_URL}/publicSurvey/${id}`, {
      credentials: "include" ,method: 'DELETE',
      headers,
    });

    const data = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return data;
} catch (error: any) {
    throw new Error(error);
}
}
  

export async function deleteQuestionApi(id: string): Promise<void> {
  try {
    const headers = await buildHeaders(BASE_URL);
    const response = await fetch(`${BASE_URL}/bank-questions/${id}`, {
      credentials: "include" ,method: 'DELETE',
      headers,
    });
    const data = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return data;
} catch (error: any) {
    throw new Error(error);
}
}

export async function getSurveyQuestionByQuarter(riskId: any, quarter: string,year:number): Promise<any> {
    try {
      const headers = await buildHeaders(BASE_URL);
      const response = await fetch(`${BASE_URL}/survey-assessment/oneQuestion/${riskId}/quarter/${quarter}/year/${year}`, {
        method: 'GET',
        headers,
        credentials: "include",
      });
  
      const data = await response.json();
      if (!response.ok || !data.success) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        //console.log("Failed to fetch");
      }
      return data;
    } catch (error: any) {
      //console.log(error);
    }
  
}

export async function getSurveyQuestionByQuarterByPage(riskId: any, quarter: string, year: number, page: number, size: number, search?: string): Promise<any> {
  try {
    const headers = await buildHeaders(BASE_URL);
    let url = `${BASE_URL}/survey-assessment/${riskId}/quarter/${quarter}/year/${year}/page/${page}/size/${size}`;
    if (search && search.trim()) {
      url += `?search=${encodeURIComponent(search.trim())}`;
    }
    const response = await fetch(url, {
      method: 'GET',
      headers,
      credentials: "include",
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      //console.log("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    //console.log(error);
  }
}


/** WAPT08: Valid year range for survey assessment (matches backend). */
const MIN_YEAR = 1900;
const MAX_YEAR = 2100;
/** WAPT08: Valid quarter values (matches backend). */
const VALID_QUARTER_PATTERN = /^(1|2|3|4|01|02|03|04|Q1|Q2|Q3|Q4)$/i;

export async function assesstQuestion(body: any): Promise<any> {
  try {
    // WAPT08: Client-side validation for year and quarter (matches backend DTO)
    const year = body?.year != null ? Number(body.year) : NaN;
    if (!Number.isInteger(year) || year < MIN_YEAR || year > MAX_YEAR) {
      return { success: false, message: 'Year must be between 1900 and 2100' };
    }
    const quarterRaw = body?.quarter != null ? String(body.quarter).trim() : '';
    if (!quarterRaw || !VALID_QUARTER_PATTERN.test(quarterRaw)) {
      return { success: false, message: 'Quarter must be 1, 2, 3, 4, 01-04, or Q1-Q4' };
    }

    const headers = await buildHeaders(BASE_URL);
    const response = await fetch(`${BASE_URL}/survey-assessment`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ ...body, year, quarter: quarterRaw }),
      credentials: "include",
    });

      const data = await response.json();
      if (!response.ok || !data.success) {
          if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
              throw new Error("Forbidden: You do not have permission to access this resource.");
          }
          //console.log("Failed to fetch");
      }
      return data;
  } catch (error: any) {
   
  }
}

export async function getRCSAByPage( quarter: string | null, year: number | null, page: number, pageSize: number, search?: string, controlReferenceId?: string): Promise<any> {
  try {
    const headers = await buildHeaders(BASE_URL);
    // 'all' asks the backend to skip that condition entirely — the catalog's
    // default view, before the user picks a period in the filter panel.
    let url = `${BASE_URL}/survey-assessment/compliance-data/quarter/${quarter || 'all'}/year/${year || 'all'}/page/${page}/size/${pageSize}`;
    const params = new URLSearchParams();
    if (search && search.trim()) {
      params.append('search', search.trim());
    }
    if (controlReferenceId && controlReferenceId.trim()) {
      params.append('controlReferenceId', controlReferenceId.trim());
    }
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    const response = await fetch(url, {
      method: 'GET',
      headers,
      credentials: "include",
    });
    const data = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return data;
} catch (error: any) {
    throw new Error(error);
}
}

export async function updateSurveyApi(id: any, body: any): Promise<any> {
  try {
    const headers = await buildHeaders(BASE_URL);
    const fullUrl = `${BASE_URL}/publicSurvey/${id}`;
    const response = await fetch(fullUrl, {
      credentials: "include",
      method: "PATCH",
      headers,
      body: JSON.stringify(body),
    });

    const data = await response.json();
    //console.log("Update API Response:", data); // Log the response

    if (!response.ok) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(data.message || "Failed to update survey");
    }

    // Handle both wrapped and direct responses
    if (data.success !== undefined) {
      // Wrapped response with success property
      if (!data.success) {
        throw new Error(data.message || "Update failed");
      }
      return data;
    } else {
      // Direct response (no success wrapper) - treat as success
      return { success: true, data: data, message: "Survey updated successfully" };
    }
  } catch (error: any) {
    console.error("Error in updateSurveyApi:", error);
    throw error;
  }
}



export async function uploadExcelForRCSA(file: File) {
  try {
      const headers = await buildHeadersForUpload(BASE_URL);
      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch(`${BASE_URL}/survey-assessment/excel`, {
          method: "POST",
          body: formData,
          headers,
          credentials: "include",
      });

      const data = await response.json();
      if (!response.ok ) {
          if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
              throw new Error("Forbidden: You do not have permission to access this resource.");
          }
          throw new Error("Failed to fetch");
      }
      return data;
  } catch (error: any) {
      throw new Error(error);
  }
}




export async function uploadExcelForRiskProfile(file: File) {
  try {
      const headers = await buildHeadersForUpload(BASE_URL);
      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch(`${BASE_URL}/survey-assessment/excelForRiskProfile`, {
          method: "POST",
          body: formData,
          headers,
          credentials: "include",
      });


      const data = await response.json();
      if (!response.ok ) {
          if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
              throw new Error("Forbidden: You do not have permission to access this resource.");
          }
          throw new Error("Failed to fetch");
      }
      return data;
  } catch (error: any) {
      throw new Error(error);
  }
}


export async function updateSurveyAssessmentApi(surveyAssessmentId: string, body: any): Promise<any> {
  try {
    const headers = await buildHeaders(BASE_URL);
    const response = await fetch(`${BASE_URL}/survey-assessment/${surveyAssessmentId}`, {
      method: 'PATCH',
      headers,
      body: JSON.stringify(body),
      credentials: "include",
    });

    const data = await response.json();
    
    if (!response.ok) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(data.message || "Failed to update survey assessment");
    }

    // Handle both wrapped and direct responses
    if (data.success !== undefined) {
      // Wrapped response with success property
      if (!data.success) {
        throw new Error(data.message || "Update failed");
      }
      return data;
    } else {
      // Direct response (no success wrapper) - treat as success
      return { success: true, data: data, message: "Survey assessment updated successfully" };
    }
  } catch (error: any) {
    console.error("Error in updateSurveyAssessmentApi:", error);
    throw error;
  }
}


export async function fetchOneSurveyApi(url: string, options: RequestInit = {}): Promise<any> {
  try {
    const headers = await buildHeaders(BASE_URL);
    const fullUrl = `${BASE_URL}/${url}`;
    //console.log("Fetching from URL:", fullUrl); // Log the URL

    const response = await fetch(fullUrl, {
      ...options,
      headers,
      credentials: "include",
    });

    const data = await response.json();
    //console.log("API Response:", data); // Log the response

    if (!response.ok) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
     // console.log("Failed to fetch");
      throw new Error("Failed to fetch survey data");
    }

    // Check if data has success property (wrapped response) or is direct data
    if (data.success !== undefined) {
      // Wrapped response with success property
      if (!data.success) {
        throw new Error(data.message || "API request failed");
      }
      return data;
    } else {
      // Direct data response (no success wrapper)
      return { success: true, data: data };
    }
  } catch (error: any) {
    console.error("Error in fetchOneSurveyApi:", error); // Log the error
    throw error;
  }
}


export const updateQuestionApi = async (id: string, data: any) => {
  try {
    const headers = await buildHeaders(BASE_URL);
    const response = await fetch(`${BASE_URL}/bank-questions/${id}`, {
      method: 'PATCH',
      headers,
      body: JSON.stringify(data),
      credentials: "include",
    });

    const result = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || result.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return result;
} catch (error: any) {
    throw new Error(error);
}
};



export async function fetchOneQuestionApi(url: string, options: RequestInit = {}): Promise<any> {
  try {
    const headers = await buildHeaders(BASE_URL);
    const fullUrl = `${BASE_URL}/${url}`;
    //console.log("Fetching from URL:", fullUrl); // Log the URL

    const response = await fetch(fullUrl, {
      ...options,
      headers,
      credentials: "include",
    });

    const data = await response.json();
    //console.log("API Response:", data); // Log the response

    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      //console.log("Failed to fetch");
    }

    return data;
  } catch (error: any) {
    //console.error("Error in fetchOneApi:", error); // Log the error
    //console.log(error);
  }
}


export const fetchQuestionByReference = async (id: string) => {
  try {
    const headers = await buildHeaders(BASE_URL);
    const response = await fetch(`${BASE_URL}/bank-questions/by-reference?referenceId=${id}`, {
      method: 'GET',
      headers,
      credentials: "include",
    });

    const data = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return data;
} catch (error: any) {
    throw new Error(error);
}
};

/**
 * Send/Approve a public survey
 * @param surveyId - The ID of the survey to send/approve
 * @param body - Optional body data for the approval request
 * @returns Promise<any> - The API response
 */
export async function sendPublicSurvey(surveyId: string, body?: any): Promise<any> {
  try {
    const headers = await buildHeaders(BASE_URL);
    const response = await fetch(`${BASE_URL}/publicSurvey/${surveyId}/send`, {
      method: "POST",
      headers,
      body: body ? JSON.stringify(body) : undefined,
      credentials: "include",
    });

    const data = await response.json();
    
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(data.message || "Failed to send/approve survey");
    }
    
    return data;
  } catch (error: any) {
    console.error("Error in sendPublicSurvey:", error);
    throw error;
  }
}

/**
 * Approve a public survey
 * @param surveyId - The ID of the survey to approve
 * @param body - Optional body data for the approval request
 * @returns Promise<any> - The API response
 */
export async function approvePublicSurvey(surveyId: string, body?: any): Promise<any> {
  try {
    const headers = await buildHeaders(BASE_URL);
    const response = await fetch(`${BASE_URL}/publicSurvey/${surveyId}/approve`, {
      method: "POST",
      headers,
      body: body ? JSON.stringify(body) : undefined,
      credentials: "include",
    });

    const data = await response.json();
    
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(data.message || "Failed to approve survey");
    }
    
    return data;
  } catch (error: any) {
    console.error("Error in approvePublicSurvey:", error);
    throw error;
  }
}





export async function fetchAllQuestionsAssessment(options: RequestInit = {}): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/questions`, {
      ...options,
    });
    const data = await response.json();
    if (!response.ok) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to fetch');
  }
}

export async function getQuestionsPaged(query: string = "", perPage: number = 10, pageNo: number = 0, options: RequestInit = {}): Promise<any> {
  const params = new URLSearchParams();
  if (query) params.set('query', query);
  params.set('perPage', String(perPage));
  params.set('pageNo', String(pageNo));
  const url = `${BASE_URL}/questions/find-all-paginated?${params.toString()}`;
  try {
    const response = await authService.apiCall(url, {
      ...options,
      method: (options.method as string) || 'GET'
    });
    const data = await response.json();
    if (!response.ok) {
      if (response.status === 401 || response.status === 403 || data.message === 'Forbidden access') {
        throw new Error('Forbidden: You do not have permission to access this resource.');
      }
      throw new Error(data?.message || 'Failed to fetch');
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to fetch');
  }
}

export async function createQuestionAssessment(body: any) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/questions`, {
      method: "POST",
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to create question assessment');
  }
}

export async function fetchBankQuestionsApi(
  quarter: string,
  year: string,
  options: RequestInit = {}
): Promise<any> {
  const query = new URLSearchParams({ quarter, year }).toString();
  try {
    const response = await authService.apiCall(
      `${BASE_URL}/bank-questions/with-controls?${query}`,
      { ...options, method: (options.method as string) || 'GET' }
    );
    const text = await response.text();
    let data: any = {};
    if (text?.trim()) {
      try {
        data = JSON.parse(text);
      } catch {
        throw new Error('Invalid JSON response from server.');
      }
    }
    if (!response.ok) {
      if (response.status === 401 || response.status === 403 || data.message === 'Forbidden access') {
        throw new Error('Forbidden: You do not have permission to access this resource.');
      }
      throw new Error(data?.message || 'Failed to fetch bank questions.');
    }
    return data && typeof data.data !== 'undefined'
      ? data
      : { data: Array.isArray(data) ? data : [] };
  } catch (error: any) {
    throw new Error(error?.message || 'Unexpected error');
  }
}

export interface UpdateQuestionCategoryBody {
  en_name: string;
  ar_name: string;
}

export async function updateQuestionCategoryApi(
  categoryUuid: string,
  body: UpdateQuestionCategoryBody
): Promise<any> {
  try {
    const response = await authService.apiCall(
      `${BASE_URL}/question-categories/${categoryUuid}`,
      {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      }
    );
    const data = await response.json();
    if (!response.ok) {
      if (response.status === 401 || response.status === 403 || (data && data.message === "Forbidden access")) {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(data?.message || "Failed to update question category");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to update question category");
  }
}

export interface UpdateQuestionBody {
  en_questionText: string;
  ar_questionText: string;
}

export async function updateQuestionByUuidApi(
  questionUuid: string,
  body: UpdateQuestionBody
): Promise<any> {
  try {
    const response = await authService.apiCall(
      `${BASE_URL}/questions/${questionUuid}`,
      {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      }
    );
    const data = await response.json();
    if (!response.ok) {
      if (response.status === 401 || response.status === 403 || (data && data.message === "Forbidden access")) {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(data?.message || "Failed to update question");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to update question");
  }
}
